var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import '../../const/initiate-icon-library';
import { cbrConfig } from '../../helpers';
import i18n from '../../strings/i18n';
import { ModalOptions } from '../../typings/common';
import CBRContext from './context';
import Drawer from './drawer';
import { DrawerFooter } from './drawer/footer';
var CreditBalanceRefundDrawer = function (_a) {
    var _b = _a.config, config = _b === void 0 ? cbrConfig : _b, accountId = _a.accountId, backToAccountManagerHandler = _a.backToAccountManagerHandler, triggerAnalyticsEvent = _a.triggerAnalyticsEvent, authenticationRedirect = _a.authenticationRedirect, handleProfileClick = _a.handleProfileClick, handleClose = _a.handleClose;
    var _c = useState(ModalOptions.default), currentModal = _c[0], setCurrentModal = _c[1];
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = useState(true), removeCBRSessionStorage = _e[0], setRemoveCBRSessionStorage = _e[1];
    var value = useMemo(function () {
        return {
            accountId: accountId,
            backToAccountManagerHandler: backToAccountManagerHandler,
            config: config,
            triggerAnalyticsEvent: triggerAnalyticsEvent,
            handleProfileClick: handleProfileClick,
            isLoading: isLoading,
            setIsLoading: setIsLoading,
            setRemoveCBRSessionStorage: setRemoveCBRSessionStorage,
            removeCBRSessionStorage: removeCBRSessionStorage
        };
    }, [
        accountId,
        backToAccountManagerHandler,
        config,
        triggerAnalyticsEvent,
        handleProfileClick,
        isLoading,
        setIsLoading,
        setRemoveCBRSessionStorage,
        removeCBRSessionStorage
    ]);
    var languageInStorage = localStorage.getItem('language');
    useEffect(function () {
        if (languageInStorage) {
            i18n.changeLanguage(languageInStorage).catch(function (error) { return error; });
        }
        else {
            localStorage.setItem('language', 'en');
        }
    }, [languageInStorage]);
    return (_jsx(I18nextProvider, __assign({ i18n: i18n }, { children: _jsxs(CBRContext.Provider, __assign({ value: value }, { children: [_jsx("div", __assign({ style: { flexGrow: 1 } }, { children: _jsx(Drawer, { authenticationRedirect: authenticationRedirect, currentDrawer: currentModal, setCurrentDrawer: setCurrentModal }) })), _jsx(DrawerFooter, { handleClose: handleClose, currentDrawer: currentModal, setCurrentDrawer: setCurrentModal })] })) })));
};
export default CreditBalanceRefundDrawer;
